import { render, staticRenderFns } from "./CustomerPlan.vue?vue&type=template&id=10b90222"
import script from "./CustomerPlan.vue?vue&type=script&lang=js"
export * from "./CustomerPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports